import Container from 'react-bootstrap/Container';
import '../../assets/css/Footer.css'

const Footer = () => {
  return (
    <footer>
        <Container>
            <h4>Hero's Blog</h4>
            <p>copyright since 2022</p>
        </Container>
    </footer>
  )
}

export default Footer
